import React, { createContext, useContext, useEffect, useState } from "react";

const SettingsContext = createContext();

export const getSettings = () => {
  const defaultSettings = { theme: "light", language: "en" };

  // Load settings from localStorage or set default values
  const savedSettings = localStorage.getItem("settings");
  return savedSettings ? JSON.parse(savedSettings) : defaultSettings; // Default settings
};

export const useSettings = () => {
  return useContext(SettingsContext);
};

export const SettingsProvider = ({ children }) => {
  const [settings, setSettings] = useState(() => {
    return getSettings();
  });

  useEffect(() => {
    // Save settings to localStorage whenever they change
    localStorage.setItem("settings", JSON.stringify(settings));
  }, [settings]);

  const updateSettings = (newSettings) => {
    setSettings((prevSettings) => ({ ...prevSettings, ...newSettings }));
  };

  return (
    <SettingsContext.Provider value={{ settings, updateSettings }}>
      {children}
    </SettingsContext.Provider>
  );
};
